import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';
import "./Modal.scss";
import { confirmable } from 'react-confirm';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import locale from './locale'

class ModalBody extends React.Component {

  constructor(props){
    super(props)
    this.onCrop = this.onCrop.bind(this);
    this.generateData = this.generateData.bind(this);
  }

  onCrop() {
    this.dataUrl = this.cropper.getCroppedCanvas().toDataURL();
  }

  dataUrlToBlob(dataURL) {
    var binary = atob(dataURL.split(',')[1]);
    var array = [];
    for(var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/png',
      name: 'cropped',
      lastModifiedDate: new Date(),
    });
  }

  generateData() {
    let file = this.dataUrlToBlob(this.dataUrl);
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL( file );
    this.props.proceed({
      dataUrl: this.dataUrl,
      imageUrl,
      file,
    });
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,

      file,

      minCropBoxHeight = 100,
      minCropBoxWidth = 100,
      minCanvasWidth = 400,
      minCanvasHeight = 400,

      aspectRatioHeight,
      aspectRatioWidth,

      removeItem,
      index,
    } = this.props;

    let aspectRatio;

    if (aspectRatioWidth && aspectRatioHeight) {
      aspectRatio = aspectRatioWidth / aspectRatioHeight;
    }

		return (
      <Modal
        isShowingModal={show} // if you want to show it when component mounts, set it true

        // allowCloseByClickingShadow={false}
        // useDefaultClosebutton={true}
        onCloseModalClick={dismiss}
        // fixedHeight={300}
        fixedWidth={700}
        // overlayColor="#000"
        // contentHeight={500}

        hasHeader={false}

        hasFooter={true}
        footerType="bold" // grey, transparent, bold
        footerButtons={[
          {
            title: __('Cancel', locale),
            className: "btn btn-default pull-right",
            onClick: ()=>{
              confirm(__('Proceed to cancel uploading image?', locale))
              .then(()=>{
                cancel();
                removeItem(index)
              })
              .catch(() => {})
            }
          },
          {
            title: __('Upload', locale),
            className: "btn btn-primary pull-right",
            onClick: this.generateData
          },

        ]}
        // footerClassName=""
        // footerCustomContent={}
      >

        <div className='image-cropper'>
          <Cropper
            minCropBoxWidth={minCropBoxWidth}
            minCropBoxHeight={minCropBoxHeight}
            minCanvasWidth={minCanvasWidth}
            minCanvasHeight={minCanvasHeight}
            src={file.preview}
            style={{height: 400, width: 400}}
            // Cropper.js options
            aspectRatio={aspectRatio}
            guides={true}
            zoomable={false}
            crop={this.onCrop}
            preview='#cropper-preview'
            ref={(c)=>{this.cropper = c;}}
          />
          <div id='cropper-preview' style={{ width: 150, height: 150 }}/>
        </div>


      </Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/ImageCropper/ModalBody.js